var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "margin": "10px 5px 10px 5px"
    }
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _vm._v(" "), _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Raise Bulk Tickets"
    },
    on: {
      "click": function($event) {
        _vm.ShowRaiseTicketDiv('raise_ticket_tab')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('td', [_c('basic-select', {
    attrs: {
      "options": _vm.businessFlow,
      "placeholder": "Select Business Flow",
      "selected-option": _vm.selectedBusinessFlowObj
    },
    on: {
      "select": _vm.selectedBusinessFlow
    },
    model: {
      value: (_vm.selectedBusinessFlowObj),
      callback: function($$v) {
        _vm.selectedBusinessFlowObj = $$v
      },
      expression: "selectedBusinessFlowObj"
    }
  }, [_vm._v("SummarySelectOptionObj\n                              ")])], 1)]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "shippingIdDiv"
    }
  }, [_c('th', [_vm._v("Shipping Id's "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "white"
    }
  }, [(_vm.displayShippingDiv) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShippingIDs),
      expression: "txtShippingIDs"
    }],
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "name": "txtShippingIDs",
      "id": "txtShippingIDs",
      "rows": "7",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.txtShippingIDs)
    },
    on: {
      "change": _vm.formatShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShippingIDs = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.bulkShippingIDsMessage) ? _c('div', {
    staticClass: "commentErrMsgCss compRedCss",
    staticStyle: {
      "height": "150%"
    }
  }, [_vm._v(_vm._s(_vm.bulkShippingIDsMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    on: {
      "click": function($event) {
        _vm.ShowRaiseTicketDiv('raise_ticket')
      }
    }
  }, [_vm._v("Raise\n                                    Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "clear"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearForm($event)
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', [_c('p', {
    attrs: {
      "id": "successMsg"
    }
  })])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Search & Export"
    },
    on: {
      "click": function($event) {
        _vm.ShowRaiseTicketDiv('edit_bulk_tickets')
      }
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    staticStyle: {
      "color": "#20a8d8",
      "float": "left"
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('b', [_c('p', [_vm._v("Filter Form")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem",
      "padding-bottom": "0px"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "frmFilterTicket",
      "name": "frmFilterTicket",
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "text-align": "right",
      "padding": "0px 15px"
    }
  }, [_vm._v("Search Tagging : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "62% !important",
      "margin-top": "-5px",
      "height": "30px",
      "min-height": "37px",
      "padding": "11px"
    },
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tag"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date :")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.tillDate2,
      "not-after": _vm.toDate
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date :")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromDate,
      "not-after": _vm.tillDate1
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Source : ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    staticStyle: {
      "width": "100% ! important"
    },
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Ticket Type : ")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "disabled": _vm.ticketTypeSelect,
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Reason : ")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "disabled": _vm.reasonSelect,
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Sub Reason : ")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "disabled": _vm.subReasonSelect,
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Resolution / Action : ")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "disabled": _vm.actionSelect,
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Ticket Status : ")]), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "disabled": _vm.ticketStatusSelect,
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "10px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchButton
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFormFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v("\n                                Clear")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export")])])])])])], 1)])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (_vm.TicketDiv) ? _c('div', {
    attrs: {
      "id": "TicketDiv"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.RaiseTicketDiv) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.RaiseTicketDiv = false;
        _vm.searchBatchDiv = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h6', [_vm._v("Add Ticket ")]), _vm._v(" "), _c('div', {
    staticClass: "act_panel",
    staticStyle: {
      "height": "20px"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin": "10px 0px 0px 10px"
    },
    attrs: {
      "id": "frmTicketDiv"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "55px"
    }
  }, [_vm._v("Search Tagging : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tag"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "55px"
    }
  }, [_vm._v("\n                                Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "98px"
    }
  }, [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v("\n                                : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "left",
      "width": "47%",
      "margin-left": "16px"
    }
  }, [((_vm.selectedReasonObj.text == 'Arrange delivery') &&
    (_vm.selectedActionObj.value == _vm.Change_Appointment_Date)) ? _c('div', [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "72px"
    }
  }, [_vm._v("\n                                  Appointment Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                                ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromAppointmentDeliveryTimeValidate,
      "not-after": _vm.toAppointmentDeliveryTimeValidate
    },
    model: {
      value: (_vm.AppointmentDeliveryDate),
      callback: function($$v) {
        _vm.AppointmentDeliveryDate = $$v
      },
      expression: "AppointmentDeliveryDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.value == _vm.Alternate_Instruction_Pickup || _vm.selectedSubReasonObj.value == _vm.Pickup_Details_Updates && _vm.selectedActionObj.value == _vm.Address_Updated)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right",
      "width": "103%"
    }
  }, [_c('label', {
    staticClass: "address_label_text"
  }, [_vm._v("\n                                  Pickup Address "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": \n                                ")]), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "pickupAddress",
      "placeholder": "Enter Address",
      "rows": "4",
      "max-rows": "6",
      "id": "address-textarea"
    },
    model: {
      value: (_vm.pickupAddress),
      callback: function($$v) {
        _vm.pickupAddress = $$v
      },
      expression: "pickupAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), (((_vm.selectedReasonObj.value == _vm.Alternate_Instruction_Delivery || _vm.selectedReasonObj.value == _vm.Alternate_Instruction_Pickup) &&
    (_vm.selectedSubReasonObj.value == _vm.Reattempt_Time_Slot_Delivery || _vm.selectedSubReasonObj.value == _vm.Reattempt_Time_Slot_Pickup || _vm.selectedSubReasonObj.value == _vm.Hold_Pickup) &&
    (_vm.selectedActionObj.value == _vm.Attempt_Delivery || _vm.selectedActionObj.value == _vm.Attempt_Pickup))) ? _c('div', [_c('label', {
    staticClass: "date_time_label_text"
  }, [_vm._v("\n                                  " + _vm._s(_vm.dynamicTimeSlotLabel) + " "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                                ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": 'YYYY-MM-DD HH:mm:ss',
      "confirm": true,
      "not-before": _vm.minSelectableDateTime,
      "not-after": _vm.maxSelectableDateTime,
      "disabled-time": _vm.disablePastTime,
      "editable": false
    },
    model: {
      value: (_vm.reattemptTimeSlotWithDate),
      callback: function($$v) {
        _vm.reattemptTimeSlotWithDate = $$v
      },
      expression: "reattemptTimeSlotWithDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedReasonObj.value == _vm.Alternate_Instruction_Delivery &&
    _vm.selectedSubReasonObj.value == _vm.Contact_Updated &&
    _vm.selectedActionObj.value == _vm.Updated_Contact) ? _c('div', {
    staticStyle: {
      "width": "103%",
      "display": "flex"
    }
  }, [_c('label', {
    staticClass: "contact_label_text"
  }, [_vm._v("Contact Number "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : \n                                ")]), _vm._v(" "), _c('b-form-input', {
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "contactNumber",
      "placeholder": "Enter Contact Number"
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "left",
      "width": "49%"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "75px"
    }
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "left",
      "width": "49%"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v("\n                                  : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "left",
      "width": "48%",
      "margin-left": "27px"
    }
  }, [((_vm.selectedReasonObj.text == 'Arrange delivery') &&
    (_vm.selectedActionObj.value == _vm.ATTEMPT_DELIVERY)) ? _c('div', [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "64px"
    }
  }, [_vm._v("Reattempt Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(":\n                                  ")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "61%"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "72px"
    }
  }, [_vm._v("Order Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.orderType,
      "placeholder": "Select OrderType",
      "selected-option": _vm.selectedOrderTypeObj
    },
    on: {
      "select": _vm.selectedOrderType
    },
    model: {
      value: (_vm.orderTypeId),
      callback: function($$v) {
        _vm.orderTypeId = $$v
      },
      expression: "orderTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "72px"
    }
  }, [_vm._v("Net Payment "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticStyle: {
      "width": "70%",
      "float": "right"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v(" \n                                  Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "width": "20%",
      "margin-right": "20px"
    }
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(":\n                                ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": (Please check batch\n                                report after 10 minutes.)")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form_btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkShipment($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetTicket(_vm.selected_action)
      }
    }
  }, [_vm._v("Reset")])])])])])])])], 1) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.searchBatchDiv) ? _c('div', {
    staticStyle: {
      "margin-top": "-15px"
    },
    attrs: {
      "id": "searchBatchDiv"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "margin-bottom": "-12px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "height": "56px"
    }
  }, [_vm._v("\n            Select Date :\n            "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: (_vm.searchDate),
      callback: function($$v) {
        _vm.searchDate = $$v
      },
      expression: "searchDate"
    }
  }), _vm._v("\n             "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btnSearch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchBatch($event)
      }
    }
  }, [_vm._v("Search")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.BatchListDiv) ? _c('div', {
    attrs: {
      "id": "BatchListDiv"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "30px"
    }
  }, [_vm._v("Batch List:")]), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.BatchListDiv = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-right": "30px",
      "float": "right"
    }
  }, [_vm._v("Total Batches : " + _vm._s(_vm.batches.length) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "tableFixHead",
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom table-text-cente"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Batch Id")]), _vm._v(" "), _c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Success/Failed")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Sub Reason")]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.selected_action === 'raise_ticket_tab') ? _c('th', [_vm._v("Status")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Report")])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.batches), function(batch, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(batch.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(batch.actiondata.businessflow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("displayDateAMPMFormat")(batch.createddatetime)))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "successSpan"
    }, [_vm._v(_vm._s(batch.successTotal))]), _vm._v("/"), _c('span', {
      staticClass: "failSpan"
    }, [_vm._v(_vm._s(batch.failTotal))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(batch.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(batch.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(batch.action))]), _vm._v(" "), (_vm.selected_action === 'raise_ticket_tab') ? _c('td', [_vm._v(_vm._s(batch.batchStatus))]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_c('a', {
      staticClass: "btn btn-success",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "title": "Download"
      },
      on: {
        "click": function($event) {
          _vm.downalodBatchReport(batch.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-excel-o",
      staticStyle: {
        "color": "white"
      }
    })])])])])
  }), _vm._v(" "), (_vm.batches.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("Batch record not found")])]) : _vm._e()], 2)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.SendSMS.SendSMSDiv) ? _c('div', {
    attrs: {
      "id": "SendSMSDiv"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "close_cross",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.SendSMS.SendSMSDiv = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Send Builk SMS")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSendSMS($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.ReasonArr,
      "selected-option": _vm.SendSMS.SelectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedSMSReason
    },
    model: {
      value: (_vm.SendSMS.Reason),
      callback: function($$v) {
        _vm.SendSMS.Reason = $$v
      },
      expression: "SendSMS.Reason"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Reason')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                                  " + _vm._s(_vm.errors.first('SendSMS.Reason')) + "\n                                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.SendSMSArr,
      "selected-option": _vm.SendSMS.SelectedSendSMSObj,
      "placeholder": "Select Message"
    },
    model: {
      value: (_vm.SendSMS.Message),
      callback: function($$v) {
        _vm.SendSMS.Message = $$v
      },
      expression: "SendSMS.Message"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Message')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                                  " + _vm._s(_vm.errors.first('SendSMS.Message')) + "\n                                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send SMS")])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('h5', [_vm._v("Shipping Info ")]), _vm._v(" "), _c('div', {
    staticClass: "act_panel"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendSMS.allSelected),
      expression: "SendSMS.allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.SendSMS.checkAllSelected,
      "name": "Select All"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendSMS.allSelected) ? _vm._i(_vm.SendSMS.allSelected, null) > -1 : (_vm.SendSMS.allSelected)
    },
    on: {
      "click": _vm.selectAll,
      "__c": function($event) {
        var $$a = _vm.SendSMS.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.SendSMS.allSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.SendSMS.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.SendSMS.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Ship Pin Code")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', [_vm._v("Current Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Action Status")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.SendSMS.OtherShipmentLogArr), function(OtherShipmentLogTblEle, index) {
    return (_vm.SendSMS.OtherShipmentLogCnt > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.SendSMS.OtherShipmentShippingIDCheckedArr),
        expression: "SendSMS.OtherShipmentShippingIDCheckedArr"
      }],
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "id": OtherShipmentLogTblEle.ShippingID,
        "type": "checkbox",
        "name": "Select All"
      },
      domProps: {
        "value": OtherShipmentLogTblEle.ShippingID,
        "checked": Array.isArray(_vm.SendSMS.OtherShipmentShippingIDCheckedArr) ? _vm._i(_vm.SendSMS.OtherShipmentShippingIDCheckedArr, OtherShipmentLogTblEle.ShippingID) > -1 : (_vm.SendSMS.OtherShipmentShippingIDCheckedArr)
      },
      on: {
        "click": function($event) {
          _vm.select(OtherShipmentLogTblEle, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.SendSMS.OtherShipmentShippingIDCheckedArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = OtherShipmentLogTblEle.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.SendSMS.OtherShipmentShippingIDCheckedArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.SendSMS.OtherShipmentShippingIDCheckedArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.SendSMS.OtherShipmentShippingIDCheckedArr = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ShipPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.DestinationHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ActionStatus))])]) : _vm._e()
  }))])])])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showList == 1) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1px",
      "margin": "-15px 0px"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "10px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "20px",
      "margin-bottom": "2rem",
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 cardlistheader",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ticket List :\n              "), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "border-radius": "8px",
      "padding": "3px 8px",
      "background-color": "#f86c6b",
      "margin": "10px 5px 5px"
    },
    attrs: {
      "data-v-3188e7ab": ""
    }
  }, [_vm._v(_vm._s(_vm.listTotalCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 cardlistheader",
    staticStyle: {
      "padding": "0px",
      "margin-top": "15px",
      "margin-left": "-40px",
      "bottom": "10px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:379'),
      expression: "'required|min:6|max:379'"
    }],
    staticClass: "horizontal",
    staticStyle: {
      "resize": "horizontal",
      "max-width": "938px",
      "min-width": "360px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text",
      "name": "filter",
      "id": "filter",
      "placeholder": "Enter maximum 20 shipping ID’s",
      "title": "Enter maximum 20 shipping ID’s",
      "rows": "2",
      "cols": "20",
      "maxlength": "299"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": _vm.formatShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "61px",
      "margin-left": "10px"
    },
    attrs: {
      "id": "btnSearch",
      "disabled": _vm.searchDisable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.OnFilterClick($event)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), (_vm.btnReset == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "61px",
      "margin-left": "10px"
    },
    attrs: {
      "id": "btnReset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchCancelled()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 cardlistheader",
    staticStyle: {
      "padding": "0px",
      "margin-left": "40px"
    }
  }, [(_vm.updateTicketButtoncheck == true) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "float": "right",
      "width": "120px"
    },
    attrs: {
      "type": "button",
      "title": "Closed tickets can not get updated.",
      "id": "show-modal",
      "disabled": _vm.updateTicketButton
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Update\n                Ticket")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto",
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "tableFixHead",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.shipmentTickets), function(data, index) {
    return (_vm.shipmentTickets.length > 0) ? _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: data.shippingid
          }
        }
      }
    }, [_vm._v("\n                      " + _vm._s(data.shippingid))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.lastmodifieddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentTickets.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pageCount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.Ticketmodal),
      callback: function($$v) {
        _vm.Ticketmodal = $$v
      },
      expression: "Ticketmodal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Ticketmodal),
      expression: "Ticketmodal"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "id": "bulkEditTicketDiv"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Update Ticket")]), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('Ticketmodal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "act_panel",
    staticStyle: {
      "height": "20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 "
  }, [_c('div', {
    staticClass: "row scrollDivShipmentGrid"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Source\n                          "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "49%"
    },
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Address : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    staticClass: "txtModalAddress",
    attrs: {
      "name": "address",
      "placeholder": "",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Reason\n                          "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("PinCode : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    staticClass: "txtModalPincode",
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    attrs: {
      "name": "pincode",
      "placeholder": ""
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), (((_vm.ticketShipmentData.length == 1 && (_vm.selectedReasonObj.text == 'Arrange delivery' ||
      (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service') ||
      (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update') ||
      _vm.selectedReasonObj.text == 'Arrange pickup' ||
      _vm.editHoldTicket == true) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.ticketShipmentData.length > 1 && _vm.objTicketSearch.subReasonId != _vm.selectedSubReasonObj.value && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Reattempt Date\n                            "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate,
      "disabled": _vm.enableReattemptDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.ticketShipmentData.length == 1) ? _c('div', [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "34px"
    }
  }, [_vm._v("Payment Method : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.payMethods,
      "selected-option": _vm.selectedMethodObj,
      "placeholder": "Select Payment Method",
      "isDisabled": _vm.disPaymentMethod
    },
    on: {
      "select": _vm.selectedMethod
    },
    model: {
      value: (_vm.methodId),
      callback: function($$v) {
        _vm.methodId = $$v
      },
      expression: "methodId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('methodId')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Sub\n                          Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Contact No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    staticClass: "txtContactNo",
    attrs: {
      "name": "alternateContactNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.alternateContactNo),
      callback: function($$v) {
        _vm.alternateContactNo = $$v
      },
      expression: "alternateContactNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('alternateContactNo')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_EMAIL_ADDRESS && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Email Address : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txtModalEmailAddress",
    attrs: {
      "name": "emailAddress",
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailAddress')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.orderTypeId == 'CashOnDelivery' && (_vm.selectedActionObj.value == _vm.STATUS_CHANGED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.PAYMENT_DETAILS_CHANGE_REQUESTED))) ? _c('div', [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Net Payment : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticClass: "txtModalNetPayment",
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("\n                          Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_model_text"
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                        ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Status",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    staticClass: "model-form-textarea",
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form_btn",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkEditShipment($event)
      }
    }
  }, [_vm._v("Save")])])])])])])])])])], 1)])], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmationModal),
      expression: "confirmationModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n                " + _vm._s(_vm.messageis) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "0.2rem",
      "align": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmationModalFunction()
      }
    }
  }, [_vm._v(" OK ")])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.ticketResultModal),
      callback: function($$v) {
        _vm.ticketResultModal = $$v
      },
      expression: "ticketResultModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticketResultModal),
      expression: "ticketResultModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Result ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": '#/bulkshipment'
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Close ")])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.MPSGroupIdwithPartialRTOAllowedmodal = false
      }
    },
    model: {
      value: (_vm.MPSGroupIdwithPartialRTOAllowedmodal),
      callback: function($$v) {
        _vm.MPSGroupIdwithPartialRTOAllowedmodal = $$v
      },
      expression: "MPSGroupIdwithPartialRTOAllowedmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MPSGroupIdwithPartialRTOAllowedmodal),
      expression: "MPSGroupIdwithPartialRTOAllowedmodal"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("AWB Conflicts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "margin-left": "440px"
    },
    on: {
      "click": function($event) {
        _vm.ShowB2CHeavyRaiseTicketDiv('raise_ticket')
      }
    }
  }, [_vm._v("Raise\n          Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.MPSGroupIdwithPartialRTOAllowedmodal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto",
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "tableFixHead",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("MPS Group ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Include")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Conflict")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Partial Allowed?")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action \n")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.B2CHeavy.B2CHeavyArr), function(OtherShipmentLogTblEle, index) {
    return (_vm.B2CHeavy.B2CHeavyArr.length > 0) ? _c('tr', [_c('td', {
      staticClass: "btn-linkT router-linkT text-center"
    }, [_c('span', {
      attrs: {
        "title": "Delete MPS Group ID"
      },
      on: {
        "click": function($event) {
          _vm.deleteShippingIdByMPSGroupId(OtherShipmentLogTblEle.MultishipmentGroupid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" \n                      \n                    " + _vm._s(OtherShipmentLogTblEle.MultishipmentGroupid) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(OtherShipmentLogTblEle.IncludeShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(OtherShipmentLogTblEle.ConflictShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(OtherShipmentLogTblEle.PartialRTOAllowed))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr),
        expression: "B2CHeavy.OtherShipmentShippingIDCheckedArr"
      }],
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "id": OtherShipmentLogTblEle.ShippingID,
        "type": "checkbox",
        "name": "Select All",
        "disabled": OtherShipmentLogTblEle.PartialRTOAllowed === 'No'
      },
      domProps: {
        "value": OtherShipmentLogTblEle.ShippingID,
        "checked": Array.isArray(_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr) ? _vm._i(_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr, OtherShipmentLogTblEle.ShippingID) > -1 : (_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr)
      },
      on: {
        "click": function($event) {
          _vm.selectB2CHeavyShippingID(OtherShipmentLogTblEle, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.B2CHeavy.OtherShipmentShippingIDCheckedArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = OtherShipmentLogTblEle.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.B2CHeavy.OtherShipmentShippingIDCheckedArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.B2CHeavy.OtherShipmentShippingIDCheckedArr = $$c
          }
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.B2CHeavy.B2CHeavyArr.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pageCount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Action Bulk Shipments")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Batch Report")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Action"), _c('i', {
    staticStyle: {
      "float": "right"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sub reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Modified Date")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14173e59","hasScoped":true}!./src/views/components/b2b/bulkshipmentaction/bulkshipment.component.html
// module id = 940
// module chunks = 1